import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'spaceDivider'})
export class SpaceDivider implements PipeTransform {
  public transform(value: string): string {
    return value.replace(/,/g, ' ');
  }
}
